"use client";
import { Patch, Post } from "@/axios/AxiosFunctions";
import AuthLayout from "@/components/AuthLayout";
import { BaseURL } from "@/config/apiUrl";
import { apiHeader, RenderToast } from "@/helper/HelperFunction";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ResetPassword from "./_components/reset-password/page";
import VerifyEmail from "./_components/verify-email";
import VerifyOtp from "./_components/verify-otp/page";

const LOADING = {
  FORGET: "forgetLoader",
  VERIFY: "verifyLoader",
  RESEND: "resendLoader",
  RESET: "resetLoader",
  CMS: "cmsLoader",
};
const tabs = {
  FORGOT_PASSWORD: "forget-password",
  OTP_CODE: "otp-code",
  RESET_PASSWORD: "reset-password",
};

const ForgetPassword = () => {
  const [tab, setTab] = useState(tabs.FORGOT_PASSWORD);
  const [email, setEmail] = useState("");
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // forgot password
  const handleEmail = async (params) => {
    setLoading(LOADING.FORGET);
    const url = BaseURL("auth/forgotPassword");
    const response = await Post(url, params, apiHeader());
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: "OTP sent successfully! Please check your email.",
      });
      setTab(tabs.OTP_CODE);
    }
    setLoading(false);
  };
  // verify otp
  const verifyOtp = async (params) => {
    setLoading(LOADING.VERIFY);
    const body = {
      email,
      ...params,
    };
    const url = BaseURL("auth/validate-otp");
    const response = await Post(url, body, apiHeader());
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: "OTP verified successfully!",
      });
      setTab(tabs.RESET_PASSWORD);
    }
    setLoading(false);
  };
  // resend otp
  const resendOtp = async () => {
    const url = BaseURL("auth/resend-otp");
    setLoading(LOADING.RESEND);
    const response = await Patch(url, { email }, apiHeader());
    if (response !== undefined) {
      RenderToast({
        type: "success",
        message: "OTP sent successfully! Please check your email.",
      });
      setLoading(false);
      return true;
    }
    setLoading(false);
    return false;
  };
  // reset password
  const handleResetPassword = async (body) => {
    const params = {
      code,
      email,
      ...body,
    };
    setLoading(LOADING.RESET);
    const url = BaseURL("auth/resetPassword");
    const response = await Patch(url, params, apiHeader());
    if (response !== undefined) {
      const message = "Password reset successfully! You can now login.";
      RenderToast({
        type: "success",
        message: message,
      });
      navigate("/login");
    }
    setLoading(false);
  };

  return (
    <AuthLayout>
      {tab === tabs.FORGOT_PASSWORD && (
        <VerifyEmail
          email={email}
          setEmail={setEmail}
          loading={loading === LOADING.FORGET}
          handleEmail={handleEmail}
        />
      )}
      {tab === tabs.OTP_CODE && (
        <VerifyOtp
          email={email}
          handleOtp={verifyOtp}
          resendOtp={resendOtp}
          loading={loading === LOADING.VERIFY}
          resendOtpLoader={loading === LOADING.RESEND}
          setCode={setCode}
          code={code}
        />
      )}
      {tab === tabs.RESET_PASSWORD && (
        <ResetPassword
          handleResetPassword={handleResetPassword}
          loading={loading === LOADING.RESET}
        />
      )}
    </AuthLayout>
  );
};

export default ForgetPassword;
